var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading && _vm.warning)?_c('Warningblock',{attrs:{"showButton":_vm.canDismiss},on:{"dismiss":_vm.onWarningDismiss}},[_vm._v(" "+_vm._s(_vm.$t('ClientWarning:Text'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }